"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_1 = require("react-router");
var getBackFallback_1 = __importDefault(require("./getBackFallback"));
var useGoBack = function (originPath) {
    var location = (0, react_router_1.useLocation)();
    var navigate = (0, react_router_1.useNavigate)();
    return (0, react_1.useCallback)(function () {
        var _a;
        if (originPath) {
            navigate(originPath, { replace: true });
        }
        else if (((_a = window.history.state) === null || _a === void 0 ? void 0 : _a.idx) > 0) {
            navigate(-1);
        }
        else {
            // Browser history can lead outside Stremio when a route was opened directly.
            navigate((0, getBackFallback_1.default)(location), { replace: true });
        }
    }, [location, navigate, originPath]);
};
exports.default = useGoBack;
